import React from "react";
//import { Link } from "react-router-dom";
import StudentDashboard from "../StudentDashboard";

function HomePage() {
  return <StudentDashboard />;
}

export default HomePage;
